import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Label, Modal, Row} from 'reactstrap';
import * as Yup from "yup";
import {INTERNATIONAL} from "../../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {getCurrentDateForCodeField} from "../../../../util/DateTools";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {aybMenuService} from "../../../../jwt/_services/ayb/aybMenuService";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../../components/i18n/toolTips";
import Separator from "../../../../components/Separator";
import { FL_STATUS} from "../../../../components/i18n/formLabels";
import Switch from "react-bootstrap-switch";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import AybMenuLangs from "../../menu/_langs";


export const MenuSectionForm = forwardRef((props, ref) => {
    const path = props.path || 'ayb/menu';
    const [parent] = useState(props.parent || null);
    const [udn] = useState(props.udn || null);
    const [app] = useState(props.app || null);

    const [image, setImage] = useState(null);
    const [code, setCode] = useState(null);
    const [category, setCategory] = useState(null);
    const [modal, setModal] = useState(false);
    const [item, setItem] = useState(null);
    const [showOrder, setShowOrder] = useState(0);
    const [status, setStatus] = useState(  null);
    const [isForWine, setIsForWine] = useState( false)
    const [langs, setLangs] = useState([]);

    useEffect(() => {
    }, []);

    useImperativeHandle(ref, () => ({
        showModal(_item, _index, _category) {
            setItem(_item);
            setShowOrder(_index);
            setLangs(_item?.langs || []);
            setStatus( _item?.id ? _item?.status : true );
            setIsForWine( _item?.id ? _item?.isForWine : false );
            setCode(_item?.code || `${udn?.code.toLowerCase()}_menu_` + getCurrentDateForCodeField());
            setImage(_item?.image || null);
            setCategory(_category || null);
            setModal(!modal);
        }
    }));

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: item?.id,
            uid: item?.uid,

            // code: menu?.code,
            code: (item?.code || `${udn?.code.toLowerCase()}_menu_` + getCurrentDateForCodeField()),
            image: item?.image,
            showOrder: showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                code: code,
                image: image,
                status: status,
                showOrder: showOrder,
                category : category,
                udn : { id: udn.id },
                place : { id : parent?.id },
                langs: langs,
            }
        }

        // console.log(dataRequest);
        // return;

        if (item?.id) {
            dataRequest.item.id = item.id

            genericIndexedActions.update(path, aybMenuService, item.id, dataRequest)
        } else {
            genericIndexedActions.save(path, aybMenuService, dataRequest)
        }

        setModal(!modal);
    };

    const showModal = () => {
        setModal(!modal);
    }
    const notImplementedAction = () => {
        console.log('Not implemented')
    }



    const notImplemented = () => {
        console.log('Not implemented')
    }

    const getHeader = () => {
        return  udn?.value + '  /  ' + parent?.title + '  /  ' +  ' Menu / ' + (item?.title || '')
    }

    return <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
        <Card >
            {/*<Form onSubmit={handleSubmit(onSubmit)}>*/}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                {
                    item?.id &&  <>
                        <h2 className={'card-modal-title'} > {  getHeader() }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + item?.uid }</h5>
                    </>
                }
                <div className="float-right">
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={onSubmit}
                    />
                    {
                        item?.id &&
                        <>
                            {/*<GenericButton*/}
                            {/*    style={'table'}*/}
                            {/*    toolTip={TT_HISTORY}*/}
                            {/*    icon={'fa-clock'}*/}
                            {/*    permission={'search'}*/}
                            {/*    onClick={showHistory}*/}
                            {/*/>*/}
                            <TranslateButton item={item} service={aybMenuService} />
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_DELETE}
                                icon={'fa-trash'}
                                permission={'delete'}
                                onClick={notImplementedAction}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={showModal}
                    />
                </div>
            </CardTitle>
                <CardBody>
                    <Row>
                    {/*<Col md="6">*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>{LB_CODE}</Label>*/}
                    {/*            <Input*/}
                    {/*                type="text"*/}
                    {/*                name="code"*/}
                    {/*                placeholder={PH_CODE}*/}
                    {/*                innerRef={register}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*    <Col md="4">*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>{FL_IMAGE}</Label>*/}
                    {/*            <Input*/}
                    {/*                type="text"*/}
                    {/*                name="image"*/}
                    {/*                placeholder={PH_IMAGE}*/}
                    {/*                innerRef={register}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                        <Col  md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col  md="2">
                            <FormGroup>
                                <Label>{'Menu de vinos?'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={isForWine}
                                    onChange={() => setIsForWine(!isForWine)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <AybMenuLangs langs={langs} setLangs={setLangs} translatableLangs={item?.translatedLangs || []} />
                </CardBody>
            {/*</Form>*/}
        </Card>
    </Modal>
})